module.exports = __webpack_public_path__ + "img/39.390c62c4.jpg";